import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  font-size: ${theme.typography.sizes['2md']};
  color: ${theme.colors.neutral.black};
  margin: 0;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  gap: ${theme.spacing['2xm']};
  border-radius: ${theme.shapes.borderRadius.xm};
  box-shadow: ${theme.effects.boxShadow.card};
`

export const ButtonsRow = styled.div`
  display: flex;
  gap: 12px;
`

export const OfficeTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.xm};
  border: 1px solid ${theme.colors.alert.info[20]};
  border-radius: ${theme.shapes.borderRadius.xm};

  .office-title {
    color: ${theme.colors.primary.main} !important;
  }
`

export const RowDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.neutral.lighthover};
`

export const TableActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${theme.spacing.xm};
`

export const ActionButtons = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
`

type ColoredTextProps = {
  color: string
}

export const ColoredText = styled.span<ColoredTextProps>`
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.bold};
  color: ${({ color }) => color};
`

export const ModalRejectReason = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${theme.spacing.xm};
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 490px;
  width: 100%;
`

export const ValueRow = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: center;
`

export const ValueDivider = styled.div`
  width: 1px;
  height: 12px;
  background-color: ${theme.colors.neutral.mediumhover};
`
